




































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { InstituteInfo } from "../../_models/instituteInfo";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";

@Component
export default class EditInstituteInfoStepper extends Vue {
  @Prop() info!: InstituteInfo;
  private e1: number;
  private id: number;
  private ragioneSocialeIstituto: string;
  private indirizzoIstituto: string;
  private capComuneIstituto: string;
  private nazioneIstituto: string;
  private comuneIstituto: string;
  private telefono1Istituto: string;
  private telefono2Istituto: string;
  private emailIstituto: string;
  private pecIstituto: string;
  private codIstituto: string;
  private codMinisterialeIstituto: string;
  private emailRules: [boolean | string];
  private pecRules: [boolean | string];
  private tel1Rules: [boolean | string];
  private tel2Rules: [boolean | string];
  private comuneRules: [boolean | string];
  private ragioneRules: [boolean | string];
  private codRules: [boolean | string];
  private codMinRules: [boolean | string];

  private items: any;
  private search: object | null;
  private isLoading: boolean;

  constructor() {
    super();
    this.e1 = 0;
    this.id = this.info.id;
    this.ragioneSocialeIstituto = this.info.ragioneSocialeIstituto;
    this.indirizzoIstituto = this.info.indirizzoIstituto;
    this.capComuneIstituto = this.info.capComuneIstituto;
    this.nazioneIstituto = this.info.nazioneIstituto;
    this.comuneIstituto = this.info.comuneIstituto;
    this.telefono1Istituto = this.info.telefono1Istituto;
    this.telefono2Istituto = this.info.telefono2Istituto;
    this.emailIstituto = this.info.emailIstituto;
    this.pecIstituto = this.info.pecIstituto;
    this.codIstituto = this.info.codIstituto;
    this.codMinisterialeIstituto = this.info.codMinisterialeIstituto;
    this.ragioneRules = [true];
    this.codRules = [true];
    this.codMinRules = [true];
    this.emailRules = [true];
    this.pecRules = [true];
    this.tel1Rules = [true];
    this.tel2Rules = [true];
    this.comuneRules = [true];

    this.items = [];
    this.search = null;
    this.isLoading = false;
  }

  @Watch("search")
  onPropertyChanged(value: string) {
    if (this.items.length > 0) return;
    this.isLoading = true;
    data
      .dispatchComuniList(this["$store"])
      .then(response => {
        if (response !== null) {
          this.items = response;
        }
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      })
      .finally(() => (this.isLoading = false));
  }

  @Watch("codMinisterialeIstituto")
  onCodMChange(value: string) {
    this.codMinisterialeIstituto = value.toUpperCase();
  }

  validazioneRagione() {
    var valid: boolean = false;
    if (this.ragioneSocialeIstituto !== "") {
      valid = /^[a-zA-Zìèéùòà'.\x20]{2,50}$/.test(this.ragioneSocialeIstituto);
    }
    if (valid) {
      this.ragioneRules = [true];
    } else if (this.ragioneSocialeIstituto === "") {
      this.ragioneRules = ["Nome Istituto necessario"];
    } else {
      this.ragioneRules = [
        "Nome Istituto deve essere compreso tra i 2 e i 50 caratteri"
      ];
    }
  }
  validazioneCod() {
    if (this.codIstituto !== "") {
      this.codRules = [true];
    } else {
      this.codRules = ["Codice Fiscale necessario"];
    }
  }
  validazioneCodMinisteriale() {
    if (this.codMinisterialeIstituto !== "") {
      this.codMinRules = [true];
    } else {
      this.codMinRules = ["Codice Ministeriale necessario"];
    }
  }
  validazioneComune() {
    var valid: boolean = false;
    if (this.comuneIstituto === "") {
      this.comuneRules = [true];
    } else {
      if (this.comuneIstituto !== "") {
        valid = /^[a-zA-Zìèéùòà'\x20]{2,50}$/.test(this.comuneIstituto);
      }
      if (valid) {
        this.comuneRules = [true];
      } else {
        this.comuneRules = ["Comune non può avere più di 50 caratteri"];
      }
    }
  }
  validazioneTel() {
    var valid1: boolean = false;
    var valid2: boolean = false;
    if (this.telefono1Istituto === "" || this.telefono1Istituto === null) {
      this.tel1Rules = [true];
    } else {
      valid1 = /[0-9]{8,15}$/.test(this.telefono1Istituto);
      if (valid1) {
        this.tel1Rules = [true];
      } else {
        this.tel1Rules = ["Il numero di telefono non ha un formato corretto"];
      }
    }
    if (this.telefono2Istituto === "" || this.telefono2Istituto === null) {
      this.tel2Rules = [true];
    } else {
      valid2 = /[0-9]{8,15}$/.test(this.telefono2Istituto);
      if (valid2) {
        this.tel2Rules = [true];
      } else {
        this.tel2Rules = ["Il numero di telefono non ha un formato corretto"];
      }
    }
  }
  validazioneEmail() {
    var valid: boolean = false;
    if (this.emailIstituto !== "") {
      valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-z]{2,}$/.test(
        this.emailIstituto
      );
    }
    if (valid) {
      this.emailRules = [true];
    } else if (this.emailIstituto === "") {
      this.emailRules = ["Email Utente necessaria"];
    } else {
      this.emailRules = ["Formato Email non corretto"];
    }
  }
  validazionePec() {
    var valid: boolean = false;
    if (this.pecIstituto === "") {
      this.pecRules = [true];
    } else {
      if (this.pecIstituto !== "") {
        valid = /[a-zA-Z0-9._&-]+@[a-zA-Z0-9._&-]+\.[a-zA-Z]{2,}$/.test(
          this.pecIstituto
        );
      }
      if (valid) {
        this.pecRules = [true];
      } else {
        this.pecRules = ["Formato Pec non corretto"];
      }
    }
  }
  close() {
    bus.$emit("closeEditDialog");
    this.e1 = 1;
  }
  async executeTestInfo() {
    this.validazioneRagione();
    this.validazioneCod();
    this.validazioneCodMinisteriale();
  }
  async executeTestRecapiti() {
    this.validazioneComune();
    this.validazioneTel();
    this.validazioneEmail();
    this.validazionePec();
  }
  next() {
    this.executeTestInfo().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        this.e1 = 2;
      }
    });
  }
  save() {
    this.executeTestRecapiti().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        var payload: InstituteInfo = {
          id: this.id,
          ragioneSocialeIstituto: this.ragioneSocialeIstituto,
          indirizzoIstituto: this.indirizzoIstituto,
          capComuneIstituto: this.capComuneIstituto,
          provinciaIstituto: this.info.provinciaIstituto,
          nazioneIstituto: this.nazioneIstituto,
          comuneIstituto: this.comuneIstituto,
          telefono1Istituto: this.telefono1Istituto,
          telefono2Istituto: this.telefono2Istituto,
          emailIstituto: this.emailIstituto,
          pecIstituto: this.pecIstituto,
          codIstituto: this.codIstituto,
          codMinisterialeIstituto: this.codMinisterialeIstituto,
          dirigenteIstituto: this.info.dirigenteIstituto
        };
        user
          .dispatchEditInstituteInfo(this["$store"], payload)
          .then(() => {
            bus.$emit("editedInstitute");
            bus.$emit(
              "successfullOperation",
              "Istituto aggiornato con successo"
            );
            this.close();
          })
          .catch(error => {
            if (error.response.status === 401) {
              bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
              this["$router"].push("/login");
            } else {
              bus.$emit(
                "errorOperation",
                "Errore nella modifica delle informazioni"
              );
            }
          });
      }
    });
  }
  created() {
    data
      .dispatchComuniList(this["$store"])
      .then(result => {
        this.items = result;
      })
      .catch(error => {
        bus.$emit(
          "errorOperation",
          "Errore nel caricamento della lista comuni"
        );
      });
  }
}
